import JobRoleService from 'signup-ui-job-role/services/JobRoleService';
import { Data } from '../signup-data/DATA';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getTypeaheadTrackedUserInput } from '../store/typeahead/selectors';
import { EventName } from './EventName';
import { trackEvent } from './UsageTrackingMiddleware';
export const trackJobRoleCollected = (_action, state) => {
  const jobRole = getSignupDataValue(state, Data.JobRole);
  const jobRoleInput = getTypeaheadTrackedUserInput(Data.JobRole)(state);

  if (!jobRole) {
    return;
  }

  trackEvent(EventName.JobRoleCollected, {
    jobRole,
    jobRoleCategory: JobRoleService.getCategory({
      id: jobRole
    }),
    userInput: jobRoleInput
  });
};